import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkle } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import { NYE_LANGS } from "@/i18n/routes";
import { NYE_UI } from "@/i18n/nye";
import { useSite } from "@/context/SiteContext";
import { Container } from "@/components/common";

/** Gold notice on the home page pointing to the Fin de Año 2026 section (only while enabled, es/ca/en). */
export function NyeBanner() {
  const { lang, path } = useLang();
  const { nye } = useSite();
  if (!NYE_LANGS.includes(lang) || !nye || nye.enabled === false) return null;
  const b = NYE_UI[lang].banner;
  return (
    <aside className="bg-gold text-ink relative overflow-hidden" data-testid="home-nye-banner">
      <div className="pointer-events-none absolute inset-0 opacity-[0.12]" aria-hidden="true" style={{ backgroundImage: "radial-gradient(circle at 20% 50%, #fff 0, transparent 35%), radial-gradient(circle at 85% 30%, #fff 0, transparent 30%)" }} />
      <Container>
        <Link to={path("nye")} data-testid="home-nye-banner-link" className="group relative flex flex-col gap-3 py-5 md:py-6 md:flex-row md:items-center md:justify-between">
          <div className="flex items-start gap-4">
            <Sparkle size={18} strokeWidth={1.5} className="mt-1 shrink-0 text-ink/80 transition-transform duration-700 ease-editorial group-hover:rotate-45" aria-hidden="true" />
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink/65">{b.eyebrow}</p>
              <p className="mt-1 font-serif text-2xl md:text-3xl leading-tight">{b.title}</p>
            </div>
          </div>
          <span className="inline-flex items-center gap-2 self-start md:self-auto border border-ink/30 px-5 py-3 font-mono text-[11px] uppercase tracking-[0.2em] transition-colors duration-300 group-hover:bg-ink group-hover:text-sand group-hover:border-ink">
            {b.cta} <ArrowUpRight size={14} strokeWidth={1.5} className="transition-transform duration-500 ease-editorial group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </span>
        </Link>
      </Container>
    </aside>
  );
}
